export default __webpack_public_path__ + "static/media/card-device-blocked.6e594c67.svg";